import React from "react";
import { Button } from "antd";

const GradientButton = ({ children, ...props }) => {
    return (
        <Button
            {...props}
            style={{
                width: "100%",
                background: "linear-gradient(90deg, #f65700, #ff7a3d)",
                border: "none",
                color: "white",
                fontWeight: "bold",
                ...props.style,
            }}
        >
            {children}
        </Button>
    );
};

export default GradientButton;
